import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    versionLink: {
      textDecoration: "none",
    },
  })
);

export default useStyles